import { useEffect } from 'react';
import { Alert, Form, Modal } from 'antd';
import { ProFormTextArea } from '@ant-design/pro-components';

interface Props {
  /** Hóa đơn đang bị từ chối — chỉ cần mã để hiện tiêu đề. Null = đóng. */
  target: { billRef: string } | null;
  submitting: boolean;
  onSubmit: (reason: string) => void;
  onCancel: () => void;
}

export function RejectScanModal({ target, submitting, onSubmit, onCancel }: Props) {
  const [form] = Form.useForm<{ reason: string }>();

  useEffect(() => {
    if (target) form.setFieldsValue({ reason: '' });
  }, [target, form]);

  return (
    <Modal
      open={target !== null}
      title={target ? `Từ chối hóa đơn ${target.billRef}` : ''}
      okText="Từ chối"
      okButtonProps={{ danger: true }}
      cancelText="Hủy"
      confirmLoading={submitting}
      onCancel={onCancel}
      destroyOnHidden
      onOk={() => {
        form
          .validateFields()
          .then((values) => onSubmit(values.reason.trim()))
          .catch(() => {});
      }}
    >
      {target && (
        <>
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
            message="Khách sẽ nhận thông báo kèm lý do này"
            description="Điểm chưa cộng. Từ chối là kết thúc hóa đơn, không đảo điểm."
          />
          <Form form={form} layout="vertical" requiredMark={false}>
            <ProFormTextArea
              name="reason"
              label="Lý do từ chối"
              placeholder="Ảnh không khớp hóa đơn, mã QR thuộc bàn khác."
              rules={[
                { required: true, message: 'Nhập lý do từ chối để khách hiểu.' },
                { min: 10, message: 'Lý do quá ngắn.' },
                { max: 500, message: 'Lý do quá dài.' },
              ]}
              fieldProps={{ rows: 3 }}
            />
          </Form>
        </>
      )}
    </Modal>
  );
}
